module.exports = __webpack_public_path__ + "static/media/recharge_history.996a1ace.svg";